export default __webpack_public_path__ + "118d3c2cfb2d3f7cd1e5e9620f65a42a.png";